import { memo } from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"

import TableCell from "@material-ui/core/TableCell"
import TableRow from "@material-ui/core/TableRow"
import Checkbox from "@material-ui/core/Checkbox"
import Link from "@material-ui/core/Link"
import Box from "@material-ui/core/Box"

import IconButton from "@material-ui/core/IconButton"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked"

import { UserRoleChip } from "components/widgets"
import { UserAvatar } from "components/partials"
import { ActionCreators, useAdminDispatch } from "../Context"
import { useAppSelector } from "common/hooks"

const useStyles = makeStyles(theme => ({
  disabled: {
    opacity: theme.palette.action.disabledOpacity
  }
}))

const Row = props => {
  const { data, showCompany, showEnabled } = props
  const dispatch = useAdminDispatch()
  const classes = useStyles()
  const { user: currentUser } = useAppSelector(state => state.auth)

  function onClickEdit() {
    dispatch(ActionCreators.setToEdit(data))
  }

  function onClickDelete() {
    dispatch(ActionCreators.setToDelete([data]))
  }

  function onCheckboxChange() {
    dispatch(ActionCreators.toggleSelect(data))
  }

  const { verified, fullName, email, role, isSelected, company, enabled } = data
  const VerifiedIcon = verified ? CheckCircleIcon : RadioButtonUncheckedIcon
  const EnabledIcon = enabled ? CheckCircleIcon : RadioButtonUncheckedIcon
  const isDeleteDisabled = currentUser?.role !== "Superadmin" && !enabled

  if (currentUser?.role !== "Superadmin" && role === "Superadmin") return null

  return (
    <TableRow
      selected={isSelected}
      {...(!enabled && { className: classes.disabled })}
      onDoubleClick={onClickEdit}
    >
      <TableCell padding="checkbox">
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={onCheckboxChange}
        />
      </TableCell>

      <TableCell component="th" scope="row">
        <Box display="flex" alignItems="center" gridGap={8}>
          <UserAvatar user={data} />
          {fullName}
        </Box>
      </TableCell>

      <TableCell>
        <Link href={`mailto:${email}`}>{email}</Link>
      </TableCell>

      <TableCell align="center">
        <UserRoleChip role={role} />
      </TableCell>

      {showCompany && (
        <TableCell>
          <span>{company?.name || "Unassigned"}</span>
        </TableCell>
      )}

      <TableCell align="center">
        <VerifiedIcon fontSize="small" color="primary" />
      </TableCell>

      {showEnabled && (
        <TableCell align="center">
          <EnabledIcon fontSize="small" color="primary" />
        </TableCell>
      )}

      <TableCell align="right">
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={onClickEdit}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={onClickDelete} disabled={isDeleteDisabled}>
            <DeleteIcon />
          </IconButton>
        </Box>
      </TableCell>
    </TableRow>
  )
}

export default memo(Row)
